<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Dashboard</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div
      class="row mt-2"
      v-if="hasAccess('Attendance', 'My Staff Timesheet List')"
    >
      <div class="col-md-12">
        <p>
          Pending Timesheet for approval / rejection:
          <a
            style="text-decoration: underline"
            @click="goTimesheetsPendingList"
          >
            <span v-html="data.pendingTimesheets"></span>
          </a>
        </p>
      </div>
    </div>
    <div
      class="row mt-2"
      v-if="hasAccess('Car Park', 'My Staff Car Park Claim')"
    >
      <div class="col-md-12">
        <p>
          Pending Car Park Claim for approval / rejection:
          <a
            style="text-decoration: underline"
            @click="goCarparkClaimPendingList"
          >
            <span v-html="data.pendingCarparkClaims"></span>
          </a>
        </p>
      </div>
    </div>
    <div class="row mt-2" v-if="hasAccess('FWA', 'My Staff FWA Record')">
      <div class="col-md-12">
        <p>
          Pending FWA for approval / rejection:
          <a style="text-decoration: underline" @click="goFwaPendingList">
            <span v-html="data.pendingFwas"></span>
          </a>
        </p>
      </div>
    </div>
    <!-- /Table List -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      menus: [],
      data: {
        pendingTimesheets: 0,
        pendingCarparkClaims: 0,
        pendingFwas: 0,
      },
    };
  },

  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data;
    },
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  methods: {
    getDashboard() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getDashboardData(param)
        .then((response) => {
          if (response.data.success) {
            this.$store.state.isLoading = false;
            this.data = response.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    goTimesheetsPendingList() {
      this.$router.push("/attendance/list/pendingtimesheet");
    },
    goCarparkClaimPendingList() {
      this.$router.push("/carpark/list/pendingcarparkclaim");
    },
    goFwaPendingList() {
      this.$router.push("/fwa/pending-list");
    },
    //access right
    getMenus() {
      let param = {
        Token: this.tokenObj.Token,
        Company: this.tokenObj.Company,
      };
      this.$store.state.isLoading = true;
      API.getMenus(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.menus = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    hasAccess(parentMenu, childMenu) {
      let hasAccess = false;
      let parent = this.menus.find((c) => c.Parent == parentMenu);
      if (parent) {
        if (childMenu) {
          let selectedChild = parent.Children.find(
            (c) => c.Name == childMenu && c.Selected == true
          );
          if (selectedChild) hasAccess = true;
        } else {
          let selectedChildren = parent.Children.filter(
            (c) => c.Selected == true
          );
          hasAccess = selectedChildren && selectedChildren.length;
        }
      }
      return hasAccess;
    },
  },

  created() {
    this.getDashboard();
    this.getMenus();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Account/Dashboard.vue